import Repository from './Repository';

const SPECIAL = '/special';

export default {
  getSpecial(payload) {
    return Repository.get(`${SPECIAL}/${payload}`);
  }
};
